import axios from "axios";
import store from "@/store";
import router from "@/router";
import * as auth from "./auth.js";
import Qs from "qs";
import { MessageBox } from "element-ui";
import { message } from "@/utils/resetMessage";

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

// 正在请求的url数组
const pending = [];
// 是否正在请求
const isPending = url => pending.includes(url);
// 移除完成的请求
const removePending = url => {
  const index = pending.findIndex(item => item === url);
  pending.splice(index, 1);
};

// 请求拦截器
request.interceptors.request.use(
  function (config) {
    if (!config.headers.noIntercept && isPending(config.url)) {
      return Promise.reject(new Error("操作频繁，请稍后重试"));
    }
    pending.push(config.url);

    const token = store.getters.token;

    // 利用逻辑运算符简化if嵌套
    token && (config.headers["Authorization"] = `Bearer ${token}`);

    // 处理如果参数为空就不传递
    for (let key in config.params) {
      if (
        config.params[key] === "" ||
        config.params[key] === null ||
        config.params[key] === undefined
      ) {
        delete config.params[key];
      }
    }

    if (config.method === "post" && !(config.data instanceof FormData)) {
      config.data = Qs.stringify(config.data);
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
// 响应拦截器
// res->{message:,code:,data:{}}---->res.data
request.interceptors.response.use(
  function (response) {
    removePending(response.config.url);
    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      showStatus(res);
      return Promise.reject(new Error(res.msg || "Error"));
    }
  },
  async function (error) {
    showStatus({ msg: error.message || "网络错误，请稍后重试" });
    return Promise.reject(error);
  }
);
// 处理状态码非200情况
const showStatus = res => {
  switch (res.code) {
    case 40001:
      MessageBox.confirm("登录失效,请您重新登录!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        })
        .catch(() => {});
      break;
    default:
      break;
  }
  message({
    message: res.msg || "Error",
    type: "error",
    duration: 5 * 1000
  });
};
export default request;
